import { minScreen } from 'src/shared/utils/StyledComponentUtils';
import styled from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { BorderRadius } from 'web-common/src/shared/styles/border';
import { Colors } from 'web-common/src/shared/styles/colors';
import { Font } from 'web-common/src/shared/styles/font';
import { Mixins } from 'web-common/src/shared/styles/mixins/index';
import { ScreenWidth } from 'web-common/src/shared/styles/screenWidth';
import { Spacing } from 'web-common/src/shared/styles/spacing';

export const ContentsContainer = styled.div<{ isCartOpen?: boolean }>`
  position: relative;
  overflow: ${ifProp('isCartOpen', 'visible', 'hidden')};
  max-width: 100vw;

  ${Mixins.Media.maxWidthSmall(`
    overflow: hidden;
  `)}
`;

export const ExploreCol = styled.div`
  width: 100%;
  flex-shrink: 0;
  min-height: 60vh;
  margin-top: 16px;

  // clearfix
  :after {
    content: '.';
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
`;

export const SegmentHeaderContainer = styled.div`
  padding: ${Spacing.NONE} ${Spacing.SINGLE};
  display: flex;
  flex-direction: column;
  margin-bottom: ${Spacing.SINGLE};
`;

export const SegmentHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: flex-start;
`;

export const SegmentHeader = styled.div`
  display: flex;
  flex-direction: row;
  cursor: default;
`;

export const SegmentHeaderTitle = styled.h1`
  font-family: ${Font.Family.SANS};
  font-weight: ${Font.Weight.BOLD};
  font-size: 18px;
  line-height: 120%;
  color: ${Colors.GRAY_DARK_30};
  margin: unset;

  ${minScreen(ScreenWidth.SMALL)} {
    font-size: 22px;
    gap: ${Font.Size.XXL};
  }
`;

export const SegmentHeaderSubtitle = styled.h2`
  font-family: ${Font.Family.SANS};
  font-weight: ${Font.Weight.MEDIUM};
  font-size: ${Font.Size.S};
  color: ${Colors.GRAY_DARK_20};
  line-height: 120%;
  margin: ${Spacing.HALF} 0 0 0;

  ${minScreen(ScreenWidth.SMALL)} {
    gap: ${Font.Size.XXL};
    margin: ${Spacing.QUARTER} 0 0 0;
  }
`;

export const SEGMENT_DIVIDER_WIDTH = 43;

export const SegmentDivider = styled.div`
  position: relative;
  left: 0;

  height: 0;
  width: ${SEGMENT_DIVIDER_WIDTH}px;
  border: ${Spacing.EIGHTH} solid ${Colors.JACKFRUIT_DARK_10};
  border-radius: ${BorderRadius.S};
`;

export const SegmentDividerContainer = styled.div<{ padding?: number }>`
  background: ${Colors.GRAY_LITE_20};
  position: absolute;
  bottom: -${Spacing.SINGLE_HALF};
  left: ${Spacing.SINGLE}; // Initial value (Same as container padding)

  height: ${Spacing.QUARTER};
  width: calc(100% - ${Spacing.DOUBLE});
  border-radius: ${BorderRadius.S};
`;
